import Vue from 'vue';

export default class CommonErrorHandler {
  constructor() {}

  /**
   * GetDisplayErrorMsgString
   * @param standardError String
   * @param standardErrorDescription String
   * @returns DisplayErrorMsg
   */
  getDisplayErrorMsgString(
    standardError: string,
    standardErrorDescription: string,
  ): string {
    let msg: string | undefined = '';

    const key = this.getDisplayErrorMsgKey(
      standardError,
      standardErrorDescription,
    );

    msg = this.getDisplayErrorMsgFromKey(key, {
      error_reason: Vue.i18n.translate('Error_UnknownError'),
    });

    // if still undefined.
    if (msg == undefined) {
      msg = Vue.i18n.translate('Error_UnknownError') || '';
    }

    return msg;
  }

  /**
   * match standard error to standard list of these errors.
   * @param standardError
   * @param standardErrorDescription
   * @returns displayErrormsg
   */
  getDisplayErrorMsgKey(
    standardError: string,
    standardErrorDescription: string,
  ): string {
    return '';
  }

  /**
   * @param displayErrorMsgKey String
   * @returns displayErrorMsgFromKey
   */
  getDisplayErrorMsgFromKey(
    displayErrorMsgKey: string,
    params: object = {},
  ): string | undefined {
    return Vue.i18n.translate(displayErrorMsgKey, params);
  }

  /**
   * Clean up Error Msg
   * @augments errorMsg
   * @returns parsable json
   */
  cleanUpErrorMsg(errorMsg: string): string {
    return errorMsg.replace('GraphQL error: ', '');
  }

  /**
   * Given errorMsg from API, Get Error Msg
   * @param errorMsg raw error.message string from API
   * @return error msg
   */
  getError(errorMsg: string): string | undefined {
    const cleanedUpErrorMsg = this.cleanUpErrorMsg(errorMsg);

    try {
      const error = JSON.parse(cleanedUpErrorMsg);

      if (error !== undefined) {
        const standardError = error.error;
        const standardErrorDescription = error.errorDescription[0];

        // Validate!
        if (
          standardError !== undefined &&
          standardErrorDescription !== undefined
        ) {
          return this.getDisplayErrorMsgString(
            standardError,
            standardErrorDescription,
          );
        }
      }
    } catch (e) {
      return Vue.i18n.translate('Error_UnknownError');
    }

    return Vue.i18n.translate('Error_UnknownError');
  }
}
